import { Form, Space, Tooltip } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Dispatch, SetStateAction, memo } from 'react';

import { EditIcon } from 'assets/svg';
import TableComponent from 'components/Table/TableComponent';
import useQueryParam from 'hooks/useQueryPrams';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';

interface IProps {
  data: any;
  setEditIndex: (id: number) => void;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  loading?: boolean;
  pageInfo?: any;
}

const TableUpdateRole = ({
  data,
  setEditIndex,
  setOpenModal,
  loading,
  pageInfo,
}: IProps) => {
  const [form] = useForm();
  const queryParam = useQueryParam(),
    page = parseInt(queryParam.get('page') + '') || 1,
    page_size = parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const columns: ColumnsTypeCustom = [
    {
      width: 45,
      title: 'STT',
      render: (_, __, index) => index + 1 + page_size * (page - 1),
    },
    {
      width: 100,
      dataIndex: 'id',
      title: 'Mã chức vụ',
    },
    {
      width: 100,
      title: 'Tên chức vụ',
      dataIndex: 'jobName',
    },
    {
      width: 150,
      title: 'Quyền',
      dataIndex: ['trole', 'name'],
    },
    {
      width: 50,
      fixed: 'right',
      align: 'center',
      title: 'Thao tác',
      render: (_, __, index) => {
        const handleClickEdit = () => {
          setEditIndex(index);
          setOpenModal(true);
        };

        return (
          <Space size={'middle'} className="text-lg ">
            <Tooltip placement="top" title={'Chỉnh sửa'}>
              <EditIcon className="cursor-pointer" onClick={handleClickEdit} />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  return (
    <Content>
      <Form form={form}>
        <TableComponent
          rowKey={(record: any) => record.id}
          columns={columns}
          loading={loading}
          dataSource={data}
          pagination={{
            current: pageInfo?.currentPage,
            pageSize: pageInfo?.itemsPerPage,
            total: pageInfo?.totalItems,
            onChange: HocChangePagination(),
          }}
        />
      </Form>
    </Content>
  );
};

export default memo(TableUpdateRole);
